import { useEffect } from "react";

export const TotalGlobal = ({ formulario, setFormulario, monedaActiva }) => {
    // Formateador de números para mostrar valores con dos decimales
    const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    // Función que limpia un valor de texto, dejando solo números y puntos decimales
    const limpiarSubtotal = (valor) => parseFloat((valor || "").toString().replace(/[^0-9.]/g, "")) || 0;

    useEffect(() => {
        // Calcula la suma de los valores de totalAB para requerimientos, otros servicios y habitaciones
        const totalMonto =
            limpiarSubtotal(formulario.totalRequerimientos.totalAB) +
            limpiarSubtotal(formulario.totalOtroServicios.totalAB) +
            limpiarSubtotal(formulario.totalHabitaciones.totalAB);

        // Actualiza el estado del formulario con el monto total calculado
        setFormulario((prev) => ({
            ...prev,
            totalGlobalCotizacion: formatter.format(totalMonto),
        }));
    }, [formulario.totalRequerimientos?.totalAB, formulario.totalOtroServicios?.totalAB, formulario.totalHabitaciones?.totalAB]);

    return (
        <div className="invoice-total ms-auto p-3 border rounded shadow-sm">
            <div className="row align-items-center mb-2">
                <div className="col-6">
                    <p className="text-muted mb-0 text-start"> TOTAL GENERAL {monedaActiva} :</p>
                </div>
                <div className="col-6 text-end">
                    <input
                        disabled
                        style={{ minWidth: 120, fontWeight: "bold", textAlign: "right" }}
                        type="text"
                        className="form-control"
                        value={formulario.totalGlobalCotizacion}
                    />
                </div>
            </div>
        </div>
    );
};
